<form>
  <div class="d-flex w-100 justify-content-center align-items-start mt-2">
    <input class="form-control" [formControl]="auszControl" placeholder="AUSZ kód"/>  
    <button class="btn btn-primary ml-2 mr-2" (click)="checkUserAusz()">Rendben</button>
    <button class="btn btn-danger ms-auto" (click)="close()">Mégse</button>
  </div>
  <label *ngIf="errorMessage" class="mt-2 errorMessage">{{errorMessage}}</label>
</form>
